import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLock = () => {
  return (
    <g>
      <path d="m13.7268 6.3958h-2.083v-2.75a3.6527 3.6527 0 0 0 -7.2876.0068v2.7432h-2.083a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4536a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75zm-7.8706-2.7437a2.16 2.16 0 0 1 4.2876-.0068v2.75h-4.2876zm7.1206 10.5972h-9.9536v-6.3535h9.9536z" />
      <path d="m8 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z" />
    </g>
  );
};

export default withIcon(IconLock);
